module.exports = __webpack_public_path__ + "img/工厂-未选中.daa752c1.png";